import { Injectable } from '@angular/core';
import {CommonService} from './common.service';
import {HttpClient} from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class CancellationService {

  constructor(private commonService: CommonService,
              private httpClient: HttpClient) { }

  public getCancelReasons(filter: string): Promise<any> {
    return new Promise((resolve) => {
      this.httpClient.get(`cancel_reason?filter=${filter}`).subscribe((result) => {
        resolve(result);
      });
    });
  }

  public getCancelActions(filter?: string): Promise<any> {
    return new Promise((resolve) => {
      const request = filter ? `request_result?filter=${filter}` : `request_result`;
      this.httpClient.get(request).subscribe((result) => {
        resolve(result);
      });
    });
  }

  public cancelReturnOrder(param: number, body: any): Promise<any> {
    return new Promise((resolve) => {
      this.httpClient.put(`return_command/web/cancel/${param}`, body).subscribe((result) => {
        resolve(result);
      });
    });
  }

  public cancelReturnDetailsOrder(param: number, body: any): Promise<any> {
    return new Promise((resolve) => {
      this.httpClient.put(`return_command/web/cancel/details/${param}`, body).subscribe((result) => {
        resolve(result);
      });
    });
  }

  public cancelLoadingOrder(body: any): Promise<any> {
    return new Promise((resolve) => {
      this.httpClient.put(`loading_command/web/cancel`, body).subscribe((result) => {
        resolve(result);
      });
    });
  }

  public cancelAccessoryLoadingOrder(body: any): Promise<any> {
    return new Promise((resolve) => {
      this.httpClient.put('accessory_request/loading_command/cancel', body).subscribe((result) => {
        resolve(result);
      });
    });
  }

  public cancelLoadingOrderMaterial(body: any): Promise<any> {
    return new Promise((resolve) => {
      this.httpClient.put(`loading_command/web/cancel_material`, body).subscribe((result) => {
        resolve(result);
      });
    });
  }

  public cancelLoadingSerialOrder(body: any): Promise<any> {
    return new Promise((resolve) => {
      this.httpClient.put(`loading_command/web/cancel_serial_number`, body).subscribe((result) => {
        resolve(result);
      });
    });
  }
}


